import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  login(email, pwd, remember, recaptchaResponse, ip) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          logIn (
            email: "${email}",
            password: "${pwd}",
            remember: ${remember},
            ip: "${ip}",
            recaptchaResponse: "${recaptchaResponse}"
          ) {
            token,
            user {
              id,
              name,
              username,
              email,
              image,
              managed_by_database_connection,
              isConnected,
              twofactor_activity,
              is_two_factor_validated,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              }
            }
          }
        }
      `
    })
  },
  integrationLogin(accessToken) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          integrationLogIn (
            access_token: "${accessToken}"
          ) {
            token,
            user {
              id,
              name,
              username,
              email,
              image,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              isConnected
            }
          }
        }
      `
    })
  },
  refreshToken() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `mutation refreshToken { refreshToken { token } }`
    })
  },
  disconnected(ip) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          disconnected(
            ip:"${ip}"
          )
        }
      `
    })
  },
  verifyPermission(verifyPermission) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          verifyPermission(
            verifyPermission: ${verifyPermission}
          )
        }
      `
    })
  }
}
